import CarouselWrapper from "../../shared/carousel-wrapper";
import LogoSlides from "./logo-slides";
import PropTypes from "prop-types";
import React from "react";

import "./press.scss";

const Press = ({ defaultOptions, pressItems }) => {
  if (!pressItems || pressItems.length < defaultOptions.minPressItems)
    return null;

  const getNumSlidesToShow = (defaultOptions) => {
    const width = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    if (width < 767) {
      return defaultOptions.numPressSlidesToShowXs;
    } else if (width < 1024) {
      return defaultOptions.numPressSlidesToShowSm;
    } else {
      return defaultOptions.numPressSlidesToShowLg;
    }
  };

  const setMultipleSlides = (slidesToShow) => {
    return pressItems
      .filter((item) => item.mOLogoUrl)
      .reduce((prev, curr) => {
        let lastIndex = prev.length - 1;
        if (lastIndex === -1) {
          prev.push([curr]);
          return prev;
        } else {
          if (prev[lastIndex].length >= slidesToShow) {
            prev.push([curr]);
            return prev;
          } else {
            prev[lastIndex].push(curr);
            return prev;
          }
        }
      }, []);
  };
  const slideItems = setMultipleSlides(getNumSlidesToShow(defaultOptions));
  const slides = slideItems.map((items, index) => (
    <LogoSlides
      numSlides={slideItems.length}
      items={items}
      key={index}
      index={index}
    />
  ));
  return (
    <div className="container web-container">
      <div className="press-wrapper row">
        <h2 className="header-standard">In the News</h2>
        <CarouselWrapper slides={slides} />
      </div>
    </div>
  );
};

Press.propTypes = {
  pressItems: PropTypes.array,
};

export default Press;



// WEBPACK FOOTER //
// ./src/components/homepage/press/press.js